class SpotifyPlaylist extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
       articles: [],
       isLoading: false
    };
  }

  componentDidMount() {
    /* console.log("componentDidMount");*/
  }

  componentWillUnmount() {
    /* console.log("componentWillUnmount");*/
  }
  render () {

    let is_logged_in = false;

    let logged_in = "Logged In";

    let logged_out = "Login";

    if (is_logged_in) {
      out = logged_in;
    } else {
      out = logged_out;
    }

    return (
      <div ref="spotify">
        <div>Test Spotify</div>

         {out}

      </div>
    );
  }
}
